export const  set_layout = "inputlayout/setlayout"
export const  set_record = "inputRecord/setRecord"
export const  get_layout = "inputlayout/getlayout"
export const  fetch_report = "/inputRecord/getInputRecordsByCompanyId"
export const  delete_report = "inputRecord/deleteInputRecordsByRecordId"
export const  update_record = "inputRecord/update"
export const  comp_details = "/companies/getCompanyDetails"